import React, { useContext } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import ActivityCard from "./newActivityCard";
import { AuthContext } from "../../context/AuthContext";
import "../../assets/styles/Sports.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

// استيراد الأنماط الخاصة بـ Swiper
import "swiper/css";
import "swiper/css/pagination";

export default function LatestActivitiesMagical({
  latestActivities = [],
  loadingApi,
}) {
  const { user } = useContext(AuthContext);

  const particlesInit = async (engine) => {
    await loadFull(engine);
  };

  // إخفاء السكشن إذا كانت الأنشطة فارغة
  if (!loadingApi && latestActivities.length === 0) {
    return null;
  }

  return (
    <section className="magical-activities-section">
      {/* Animated Magical Background - Fireflies Effect */}
      <Particles
        id="tsparticles-magical"
        init={particlesInit}
        options={{
          fullScreen: { enable: false },
          background: { color: "transparent" },
          fpsLimit: 60,
          particles: {
            number: { value: 50, density: { enable: true, area: 800 } },
            color: { value: ["#ffd700", "#4cc9f0", "#e0aaff"] },
            opacity: {
              value: { min: 0.2, max: 0.8 },
              animation: { enable: true, speed: 1.5, minimumValue: 0.2 },
            },
            size: {
              value: { min: 1.5, max: 4 },
              animation: { enable: true, speed: 2, minimumValue: 1 },
            },
            shape: { type: "circle" },
            move: {
              enable: true,
              speed: 0.8,
              direction: "none",
              random: true,
              straight: false,
              outModes: "bounce",
            },
          },
          interactivity: {
            events: {
              onHover: { enable: true, mode: "bubble" },
              onClick: { enable: true, mode: "repulse" },
            },
            modes: {
              bubble: { distance: 200, size: 6, duration: 2, opacity: 1 },
              repulse: { distance: 150, duration: 0.4 },
            },
          },
        }}
        className="particles-canvas"
      />

      <div className="container position-relative z-2">
        {/* Title Area */}
        <div className="text-center mb-5">
          <span className="magical-badge">
            <i className="bi bi-sparkles me-2"></i>
            What's New
          </span>
          <h2 className="magical-title mt-3">
            Latest <span>Activities</span>
          </h2>
        </div>

        {/* سلايدر الأنشطة */}
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          grabCursor={true} // بيعمل شكل الإيد عشان يوضح إنه بيتسحب
          /* 🌟 الخواص السحرية لحل مشكلة الكروت القليلة 🌟 */
          watchOverflow={true} // لو الكروت مكفية الشاشة، بيقفل الحركة والنقط تلقائياً
          centerInsufficientSlides={true} // بيسنتر الكروت في النص لو عددهم قليل
          loop={false} // قفلنا الـ Loop عشان ميخلقش نسخ وهمية تبوظ الشكل لو الكروت قليلة
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true, // بيوقف الحركة لما الطالب يقف بالماوس على الكارت
          }}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          className="magical-swiper"
          breakpoints={{
            1200: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 25,
            },
            0: {
              slidesPerView: 1.1,
              spaceBetween: 15,
            },
          }}
        >
          {!loadingApi &&
            latestActivities.map((activity) => (
              <SwiperSlide key={activity._id} className="py-4">
                <div className="card-hover-wrapper">
                  <ActivityCard
                    _id={activity._id}
                    activityName={activity.activityName}
                    posterImage={activity.posterImage}
                    // capacity={activity.capacity}
                    // participantsCount={activity.participantsCount}
                    supervisorID={activity.supervisorID}
                    // participants={activity.participants}
                    currentUserId={user?._id}
                    role={user?.role}
                    flags={activity.flags}
                    type={activity.type}
                  />
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    </section>
  );
}

// import React, { useContext } from "react";
// import Particles from "react-tsparticles";
// import { loadFull } from "tsparticles";
// import ActivityCard from "./newActivityCard";
// import { AuthContext } from "../../context/AuthContext";
// import "../../assets/styles/Sports.css";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Pagination, Autoplay } from "swiper/modules";

// // استيراد الأنماط الخاصة بـ Swiper
// import "swiper/css";
// import "swiper/css/pagination"; // إضافة الترقيم فقط

// export default function LatestActivitiesMagical({
//   latestActivities,
//   loadingApi,
// }) {
//   const { user } = useContext(AuthContext);

//   const particlesInit = async (engine) => {
//     await loadFull(engine);
//   };

//   // إخفاء السكشن إذا كانت الأنشطة فارغة
//   if (!loadingApi && latestActivities.length === 0) {
//     return null; // هنا نرجع null لإخفاء السكشن
//   }

//   return (
//     <section
//       style={{
//         position: "relative",
//         padding: "80px 0",
//         background: "linear-gradient(180deg, #132a57, #1e3c72, #2a5298)",
//         overflow: "hidden",
//       }}
//     >
//       {/* Animated Magical Background */}
//       <Particles
//         init={particlesInit}
//         options={{
//           fullScreen: { enable: false },
//           background: { color: "transparent" },
//           fpsLimit: 60,
//           particles: {
//             number: { value: 70, density: { enable: true, area: 900 } },
//             color: { value: ["#4cc9f0", "#4361ee", "#90e0ef", "#9d4edd"] },
//             opacity: { value: 0.6, random: true },
//             size: { value: { min: 2, max: 6 }, random: true },
//             shape: { type: "circle" },
//             move: {
//               enable: true,
//               speed: { min: 1, max: 3 },
//               direction: "top",
//               outModes: "out",
//             },
//           },
//           interactivity: {
//             events: {
//               onHover: { enable: true, mode: "repulse" },
//               onClick: { enable: true, mode: "push" },
//             },
//             modes: {
//               repulse: { distance: 120, duration: 0.4 },
//               push: { quantity: 3 },
//             },
//           },
//         }}
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "100%",
//           zIndex: 0,
//         }}
//       />

//       <div className="container" style={{ position: "relative", zIndex: 2 }}>
//         <h2
//           className="text-center fw-bold mb-5"
//           style={{
//             color: "white",
//             textShadow: "0px 0px 10px rgba(255,255,255,0.4)",
//             fontSize: "2.3rem", // الحجم الافتراضي على الشاشات الكبيرة
//           }}
//         >
//           <i className="bi bi-stars me-2" style={{ color: "#ffd700" }}></i>
//           Latest Activities
//         </h2>

//         {/* سلايدر الأنشطة */}
//         <Swiper
//           modules={[Pagination, Autoplay]}
//           spaceBetween={20}
//           centeredSlides={false}
//           loop={latestActivities.length > 3}
//           autoplay={{ delay: 3500, disableOnInteraction: false }}
//           pagination={{ clickable: true }} // إضافة الترقيم فقط
//           breakpoints={{
//             1200: {
//               slidesPerView: 3, // عرض 3 كروت في الديسكتوب
//               spaceBetween: 30,
//             },
//             768: {
//               slidesPerView: 2, // عرض 2 كارد على التابلت
//               spaceBetween: 20,
//             },
//             0: {
//               slidesPerView: 1.2, // عرض كارد واحد جزئي على الموبايل
//               spaceBetween: 15, // المسافة بين الكروت
//             },
//           }}
//         >
//           {!loadingApi &&
//             latestActivities.map((activity) => (
//               <SwiperSlide key={activity._id}>
//                 <ActivityCard
//                   _id={activity._id}
//                   activityName={activity.activityName}
//                   posterImage={activity.posterImage}
//                   capacity={activity.capacity}
//                   participantsCount={activity.participantsCount}
//                   supervisorID={activity.supervisorID}
//                   participants={activity.participants}
//                   currentUserId={user?._id}
//                   role={user?.role}
//                   flags={activity.flags}
//                   type={activity.type}
//                 />
//               </SwiperSlide>
//             ))}
//         </Swiper>
//       </div>
//     </section>
//   );
// }
